import { Button, Card, Col, Row, Typography } from 'antd'
import React from 'react'
import PaymentModal from '../Packages/PaymentModal'
import { formatNumber } from '../../utils';
import { NavLink } from 'react-router-dom';

interface PackageItemCardProps {
    course: any
    setBuyer: any
}

const PackageItemCard: React.FC<PackageItemCardProps> = ({ course, setBuyer }) => {

    const { Title, Text } = Typography;
    const badgeText = typeof course?.badgeText === 'string' ? course.badgeText.trim() : '';

    return (
        <>
            <Card
                bodyStyle={{ padding: 16, height: '100%', paddingTop: 0, flex: '1 1 auto' }}
                className={`course-card ${course?.free ? 'free' : 'paid'}`}
                actions={
                    [<Row key="course-actions" justify={"space-between"} gutter={[16, 16]} style={{ margin: '0px 8px' }}>
                        <Col span={12}>
                            <NavLink to={`/course/${course.id}`}>
                                <Button className='w-full detail-btn' size="large" type="link">Detay</Button>
                            </NavLink>
                        </Col>
                        <Col span={12}>
                            <PaymentModal packageItem={course} setBuyer={setBuyer} />
                        </Col>
                    </Row>]
                }
            >
                <NavLink
                    className="course-card__content-link"
                    to={`/course/${course.id}`}
                    aria-label={`${course?.name ?? 'Kurs'} detayını aç`}
                >
                    {badgeText && <span className="course-card__badge">{badgeText}</span>}
                    <Title level={4}>{course?.name}</Title>
                    {(course?.free) ? <Row justify={"start"} gutter={[8, 8]} align={"bottom"}>
                        <Col>
                            <Title className='m-0' level={5}>Ücretsiz</Title>
                        </Col>
                    </Row> : <Row justify={"start"} gutter={[8, 8]} align={"bottom"}>
                        <Col>
                            <Title className='m-0' level={4}>{formatNumber(course.salePrice)} ₺</Title>
                        </Col>
                        <Col>
                            <Text className='text-red' delete>{formatNumber(course.listPrice)} ₺</Text>
                        </Col>
                    </Row>}

                    <Row style={{ minHeight: '100%' }}>
                        <Col>
                            <div dangerouslySetInnerHTML={{ __html: course?.subhead }} />
                        </Col>
                    </Row>
                </NavLink>
            </Card>
        </>
    )
}

export default PackageItemCard
